<template>
  <span>
    <div class="boss-scout-confirm-container">
      <div
        class="boss-scout-confirm-header pega-break"
        data-test="subject"
      >件名：{{ subject }}</div>
      <div class="boss-scout-confirm-body pega-pre-wrap">
        <div class="boss-scout-confirm-contents">
          <div class="boss-scout-confirm-contents-text clearfix">
            <div
              class="boss-scout-confirm-contents-sentence float-left pega-break"
              data-test="body"
              v-html="$sanitize(renderBody)"
            />
          </div>
          <div class="boss-scout-confirm-bonus">
            <span
              v-for="(specialFavorId, i) in specialFavorIds"
              :key="i"
              v-tooltip="{ content: specialFavorBy(specialFavorId).description}"
              :data-test="'special-favor-id-' + specialFavorId"
              class="boss-bonus-check-text boss-check-true"
            >{{ convertLabelById(specialFavorId, 'specialFavors') }}</span>
          </div>
        </div>
      </div>
      <div
        v-if="reservationDate"
        class="boss-scout-confirm-footer"
      >
        <div data-test="reservation-name">
          スカウト送信予約名：{{ reservationName }}
        </div>
        <div data-test="reservation-date">
          送信日時：{{ reservationDate }}
        </div>
      </div>
    </div>
    <div class="boss-button-container">
      <button
        class="boss-button boss-button-return"
        type="button"
        data-test="back-button"
        @click="$emit('switchingState', true)"
      >
        <span class="boss-button-return-text">戻る</span></button>
      <button
        :disabled="isScoutSendDisabled"
        class="boss-button-center boss-button-confirm pega-button"
        type="button"
        data-test="confirm-button"
        @click="$emit('registerScoutMessages')"
      ><span
        class="boss-button-confirm-text"
        data-test="confirm-label"
      >{{ reservationDate ? 'この内容で送信予約をする' : 'この内容で送信する' }}</span></button>
    </div>
  </span>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import util from '@/lib/util'
export default {
  props: {
    subject: {
      type: String,
      required: true
    },
    body: {
      type: String,
      required: true
    },
    specialFavorIds: {
      type: Array,
      required: true
    },
    isScoutSendDisabled: {
      type: Boolean,
      required: true
    },
    reservationDate: {
      type: String,
      default: ''
    },
    reservationName: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      convertLabelById: 'convertLabelById',
      specialFavorBy: 'specialFavorBy'
    }),
    renderBody () {
      return util.replaceAddressAndUrlLink(this.body)
    }
  },
  created () {
    this.storeMaster('specialFavors')
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ])
  }
}
</script>
